import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import { Tabs } from '@liminal/web-ui/primitives/Tabs';

const subTabs = [
  { label: 'Flags', path: '/fflags/flags' },
  { label: 'Users', path: '/fflags/users' },
];

export function FFlagsPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const active = subTabs.find(
    (tab) => location.pathname === tab.path || location.pathname.startsWith(tab.path + '/'),
  );

  return (
    <Stack spacing={3}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={(active ?? subTabs[0]).path}
          onChange={navigate}
          aria-label="Feature flag sections"
          items={subTabs.map((tab) => ({ value: tab.path, label: tab.label }))}
        />
      </Box>
      <Outlet />
    </Stack>
  );
}
